module.exports = __webpack_public_path__ + "static/media/tasty.d6aebc81.mp4";